import { jsx } from "panel";
import { InputEl } from "common/components/input";
import { SelectEl } from "common/components/select";
import { ToggleEl } from "common/components/toggle";
import { ToggleTheme } from "common/components/toggle/types";
import { TooltipEl } from "common/components/tooltip";
import { DisplayType } from "common/components/tooltip/types";
import { InputSize } from "common/components/input/types";
import { SelectTheme } from "common/components/select/constants";
import { ButtonSize } from "common/components/button/constants";
import { pluralize } from "common/util/string";
import { TimeUnitLabels } from "common/widgets/date-range-picker/models/types";
import groupSizeImg from "common/assets/images/custom-groups/group-size.svg";
import { BucketType } from "../types";
export function UnitsSelect(_ref) {
  let {
    cmp
  } = _ref;
  return cmp.helpers.canSelectBucketUnit() ? /* @__PURE__ */ jsx(SelectEl, { sel: ".mp-bucket-pane-input", attrs: {
    elref: "filterUnit",
    "disable-search": true,
    "menu-width": 200,
    "menu-height": 0,
    sections: cmp.helpers.getBucketUnits(),
    "selected-option": pluralize(TimeUnitLabels[cmp.unit], true),
    theme: SelectTheme.Tertiary,
    "never-show-caret": true,
    tooltip: {
      text: "Time Unit to be applied to the bucket values"
    },
    "help-text": "Time Unit to be applied to the bucket values"
  }, on: {
    change: cmp.helpers.changeBucketUnit
  }, "data-sentry-element": "SelectEl", "data-sentry-component": "UnitsSelect", "data-sentry-source-file": "template.tsx" }) : null;
}
export function EvenGroup(_ref2) {
  let {
    cmp
  } = _ref2;
  const {
    t
  } = cmp.getContext("i18n");
  return /* @__PURE__ */ jsx("div", { sel: ".content-area", "data-sentry-component": "EvenGroup", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".range-section" }, /* @__PURE__ */ jsx("div", { sel: ".input-group" }, /* @__PURE__ */ jsx(InputEl, { sel: ".mp-bucket-pane-input", attrs: {
    "auto-focus": true,
    "pre-text": t("query-builder.buckets.min"),
    size: InputSize.Medium,
    type: "number",
    "validation-status": cmp.helpers.getMinValidationStatus()
  }, on: {
    input: cmp.helpers.changeBucketMin
  }, props: {
    value: cmp.helpers.getMin().toString()
  }, hook: {
    insert: cmp.helpers.selectDefault
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(InputEl, { sel: ".mp-bucket-pane-input", attrs: {
    "pre-text": t("query-builder.buckets.max"),
    size: InputSize.Medium,
    type: "number",
    "validation-status": cmp.helpers.getMaxValidationStatus()
  }, on: {
    input: cmp.helpers.changeBucketMax
  }, props: {
    value: cmp.helpers.getMax().toString()
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" }))), /* @__PURE__ */ jsx("div", { sel: ".interval-section" }, /* @__PURE__ */ jsx("div", { sel: cmp.helpers.canSelectBucketUnit() ? ".input-group" : ".mp-bucket-pane-field" }, /* @__PURE__ */ jsx(InputEl, { sel: ".mp-bucket-pane-input", attrs: {
    "help-text": t("query-builder.buckets.size-tooltip", {
      sizeImg: groupSizeImg
    }),
    "pre-text": t("query-builder.buckets.size"),
    type: "number",
    size: InputSize.Medium,
    "validation-status": cmp.helpers.getBucketSizeValidationStatus()
  }, on: {
    input: cmp.helpers.changeBucketSize
  }, props: {
    value: cmp.helpers.getBucketSize().toString()
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(UnitsSelect, { cmp, "data-sentry-element": "UnitsSelect", "data-sentry-source-file": "template.tsx" }))));
}
export function UnevenGroup(_ref3) {
  let {
    cmp
  } = _ref3;
  const {
    t
  } = cmp.getContext("i18n");
  return /* @__PURE__ */ jsx("div", { sel: ".vertical-input-group .content-area", "data-sentry-component": "UnevenGroup", "data-sentry-source-file": "template.tsx" }, cmp.helpers.getUnevenBuckets().map((group, index) => /* @__PURE__ */ jsx(InputEl, { sel: ".mp-bucket-pane-input", attrs: {
    "pre-text": t("query-builder.buckets.value"),
    size: InputSize.Medium,
    type: "number"
  }, on: {
    input: (ev) => cmp.helpers.changeBucketGroup(ev, index),
    focusout: cmp.helpers.sortUnevenBuckets
  }, props: {
    value: (group !== null && group !== void 0 ? group : "").toString()
  }, hook: {
    postpatch: (vnode) => index === 0 && cmp.helpers.selectDefault(vnode)
  } })), /* @__PURE__ */ jsx(UnitsSelect, { cmp, "data-sentry-element": "UnitsSelect", "data-sentry-source-file": "template.tsx" }));
}
export function template() {
  const {
    t
  } = this.getContext("i18n");
  const {
    tooltipErrorMsg
  } = this.state;
  return this.params.useNewDesign ? /* @__PURE__ */ jsx("div", { sel: ".new-style", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, tooltipErrorMsg && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "always-show": true,
    "hide-arrow": true,
    type: DisplayType.Error
  } }, tooltipErrorMsg), /* @__PURE__ */ jsx(ToggleEl, { sel: ".toggle-el", attrs: {
    theme: ToggleTheme.TabBar,
    options: [{
      label: t("query-builder.buckets.evenly-divided"),
      value: BucketType.Even,
      tooltipLabel: t("query-builder.buckets.evenly-divided-tooltip")
    }, {
      label: t("query-builder.buckets.varied-sizes"),
      value: BucketType.Varied,
      tooltipLabel: t("query-builder.buckets.varied-sizes-tooltip")
    }, {
      label: t("query-builder.buckets.no-buckets"),
      value: BucketType.None,
      tooltipLabel: t("query-builder.buckets.no-buckets-tooltip")
    }],
    selected: this.state.currentTab
  }, on: {
    select: this.helpers.handleTabClick
  }, "data-sentry-element": "ToggleEl", "data-sentry-source-file": "template.tsx" }), this.state.currentTab === BucketType.Even && /* @__PURE__ */ jsx(EvenGroup, { cmp: this }), this.state.currentTab === BucketType.Varied && /* @__PURE__ */ jsx(UnevenGroup, { cmp: this }), /* @__PURE__ */ jsx("div", { sel: ".bucket-preview" }, this.getBucketPreview())) : /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-pane", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, tooltipErrorMsg && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "always-show": true,
    "hide-arrow": true,
    type: DisplayType.Error
  } }, tooltipErrorMsg), /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-pane-title" }, this.params.header), /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-pane-content" }, /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-pane-row" }, /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-pane-field" }, /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-pane-label" }, "Interval Size"), /* @__PURE__ */ jsx(InputEl, { sel: ".mp-bucket-pane-input", attrs: {
    type: "number",
    "validation-status": this.helpers.getBucketSizeValidationStatus()
  }, on: {
    input: this.helpers.changeBucketSize
  }, props: {
    value: this.helpers.getBucketSize().toString()
  }, hook: {
    insert: this.helpers.selectDefault
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-pane-field" }, this.helpers.canSelectBucketUnit() ? /* @__PURE__ */ jsx(SelectEl, { attrs: {
    sections: this.helpers.getBucketUnits(),
    size: ButtonSize.Large,
    elref: "bucketUnitSelector"
  }, on: {
    change: this.helpers.changeBucketUnit
  } }) : null)), /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-pane-row" }, /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-pane-field" }, /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-pane-label" }, "Minimum"), /* @__PURE__ */ jsx(InputEl, { sel: ".mp-bucket-pane-input", attrs: {
    type: "number",
    "validation-status": this.helpers.getMinValidationStatus()
  }, on: {
    input: this.helpers.changeBucketMin
  }, props: {
    value: this.helpers.getMin().toString()
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-pane-field" }, /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-pane-label" }, "Maximum"), /* @__PURE__ */ jsx(InputEl, { sel: ".mp-bucket-pane-input", attrs: {
    type: "number",
    "validation-status": this.helpers.getMaxValidationStatus()
  }, on: {
    input: this.helpers.changeBucketMax
  }, props: {
    value: this.helpers.getMax().toString()
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" })))));
}
